import { render, staticRenderFns } from "./origin-info.vue?vue&type=template&id=a3f39ad4"
import script from "./origin-info.vue?vue&type=script&lang=js"
export * from "./origin-info.vue?vue&type=script&lang=js"
import style0 from "./origin-info.vue?vue&type=style&index=0&id=a3f39ad4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports